// ---- Sample Data (replace with your own) ----
const FieldsData = /** @type {Field[]} */ ([
  {
    id: "field-1",
    name: "South P Lot - Stony Brook University ",
    address: "South P Lot, Stony Brook, NY 11794",
    town: "Stony Brook",
    state: "NY",
    zip: "11794",
    surface: "Grass",
    lights: true,
    parking: "Lot",
    notes: "Enter via Nicolls Rd or Stony Brook Rd"
  },
  {
    id: "field-2",
    name: "SSG James D. McNaughton Memorial Park (Centereach Turf)",
    address: "33 Horseblock Rd, Centereach, NY 11720",
    town: "Centereach",
    state: "NY",
    zip: "11720",
    surface: "Turf",
    lights: true,
    parking: "Lot",
    notes: "Located across the street from the Centereach Lanes."
  },
    {
    id: "field-3",
    name: "The Stony Brook School",
    address: "1 Chapman Pkwy, Stony Brook, NY 11790",
    town: "Stony Brook",
    state: "NY",
    zip: "11790",
    surface: "Turf",
    lights: true,
    parking: "Lot",
    notes: ""
  },
  {
    id: "field-4",
    name: "Percy B Raynor Memorial Park",
    address: "Percy B Raynor Memorial Park, Centereach, NY 11720",
    town: "Centereach",
    state: "NY",
    zip: "11720",
    surface: "Turf",
    lights: true,
    parking: "Lot",
    notes: "Two adjacent turf fields"
  },
  {
    id: "field-5",
    name: "Veterans Park",
    address: "Hemlock Street and Boyle Rd, Selden, NY 11784",
    town: "Selden",
    state: "NY",
    zip: "11784",
    surface: "Turf",
    lights: true,
    parking: "Lot",
    notes: ""
  },
  {
    id: "field-6",
    name: "Medford Athletic Complex",
    address: "Medford Athletic Complex, Medford, NY 11763",
    town: "Medford",
    state: "NY",
    zip: "11763",
    surface: "Turf",
    lights: true,
    parking: "Lot",
    notes: ""
  },
  {
    id: "field-7",
    name: "North Coleman Elementary School",
    address: "197 N Coleman Rd, Centereach, NY 11720",
    town: "Centereach",
    state: "NY",
    zip: "11720",
    surface: "Grass",
    lights: false,
    parking: "Lot and Street",
    notes: ""
  },
  {
    id: "field-8",
    name: "Stagecoach Elementary School",
    address: "205 Dare Rd, Selden, NY 11784",
    town: "Selden",
    state: "NY",
    zip: "11784",
    surface: "Grass",
    lights: false,
    parking: "Lot",
    notes: ""
  },
  {
    id: "field-9",
    name: "Ward Melville High School",
    address: "380 Old Town Road, East Setauket, NY 11733",
    town: "East Setauket",
    state: "NY",
    zip: "11733",
    surface: "Turf",
    lights: true,
    parking: "Lot",
    notes: ""
  },
  {
    id: "field-10",
    name: "Centereach High School",
    address: "14 43rd St, Centereach, NY 11720",
    town: "Centereach",
    state: "NY",
    zip: "11720",
    surface: "Turf",
    lights: true,
    parking: "Lot",
    notes: ""
  },
  {
    id: "field-11",
    name: "Selden Middle School",
    address: "22 Jefferson Ave, Centereach, NY 11720",
    town: "Centereach",
    state: "NY",
    zip: "11720",
    surface: "Turf",
    lights: true,
    parking: "Lot",
    notes: ""
  }
]);

export default FieldsData